import { useState, useEffect } from "react";
import { useGerenciamento } from "../Context/GerenciamentoContext";
import { Link, useNavigate } from 'react-router-dom';
import "../../App.css";
import "./Forms.css";

import cadastro from "../../assets/icons/perfil.png";

import CadastrosInternosService from "../../services/CadastrosInternosService";
import formCadastroDTO from "../../types/FormCadastroDTO";
import formCadastroUpdateDTO from "../../types/FormCadastroUpdateDTO";

export default function FormCadastros({
  itemSelecionado,
  modo,
  onClose,
}) {
  const [form, setForm] = useState({
    idCadastro: null,
    nome: "",
    nascimento: "",
    email: "",
    login: "",
    senha: "",
    confirmarSenha: "",
    celular: "",
    rua: "",
    numero: "",
    bairro: "",
    complemento: "",
    cep: "",
    cidade: "",
    uf: "",
    acesso: 2,
    ativo: true,
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [buscandoCep, setBuscandoCep] = useState(false);
  const { setRetorno } = useGerenciamento();
  const [submitState, setSubmitState] = useState("IDLE"); 
  const [confirmarAdmin, setConfirmarAdmin] = useState(false);

  // ==========================
  // LOAD MODO
  // ==========================
  useEffect(() => {
    if (modo === "novo") {
      setForm({
        idCadastro: null,
        nome: "",
        nascimento: "",
        email: "",
        login: "",
        senha: "",
        confirmarSenha: "",
        celular: "",
        rua: "",
        numero: "",
        bairro: "",
        complemento: "",
        cep: "",
        cidade: "",
        uf: "",
        acesso: 2,
        ativo: true,
      });
    }
  
    if (modo === "alterar" && itemSelecionado) {
      setForm({
        idCadastro: itemSelecionado.IDCADASTRO || null,
        nome: itemSelecionado.NOME || "",
        nascimento: itemSelecionado.NASCIMENTO
          ? itemSelecionado.NASCIMENTO.substring(0, 10)
          : "",
        email: itemSelecionado.EMAIL || "",
        login: itemSelecionado.LOGIN || "",
        senha: "",
        confirmarSenha: "",
        celular: itemSelecionado.CELULAR || "",
        rua: itemSelecionado.RUA || "",
        numero: itemSelecionado.NUMERO || "",
        bairro: itemSelecionado.BAIRRO || "",
        complemento: itemSelecionado.COMPLEMENTO || "",
        cep: itemSelecionado.CEP || "",
        cidade: itemSelecionado.CIDADE || "",
        uf: itemSelecionado.uf || "",
        acesso: Number(itemSelecionado.ACESSO) || 2,
        ativo: Boolean(itemSelecionado.ATIVO),
      });
    }
  
    setConfirmarAdmin(false);
  }, [modo, itemSelecionado]);
  // ==========================
  // HANDLERS
  // ==========================
  function handleChange(e) {
    const { name, value } = e.target;

    if (name === "ativo") {
      setForm({ ...form, ativo: value === "true" });
      return;
    }

    if (name === "acesso") {
      const novoAcesso = Number(value);

      if (modo === "alterar" && novoAcesso === 1 && !confirmarAdmin) {
        const ok = window.confirm("Confirma alteração para Administrador?");
        if (!ok) return;
        setConfirmarAdmin(true);
      }
      setForm({ ...form, acesso: novoAcesso  });
      return;
    }


    setForm({ ...form, [name]: value });
  }

  // ==========================
  // CEP
  // ==========================
  async function buscarCep() {
    const cepLimpo = form.cep.replace(/\D/g, "");

    if (cepLimpo.length !== 8) {
      alert("CEP inválido. Digite 8 números.");
      //setRetorno({ tipo: "erro", mensagem: "CEP inválido. Digite 8 números." });
      return;
    }

    try {
      setBuscandoCep(true);

      const resposta = await fetch(`https://viacep.com.br/ws/${cepLimpo}/json/`);
      
      if (!resposta.ok) {
        alert("Erro ao consultar o CEP.");
        //setRetorno({ tipo: "erro", mensagem: "Erro ao consultar o CEP." });
        return;
      }

      const dados = await resposta.json();

      if (dados.erro) {
        alert("CEP não encontrado.");
        //setRetorno({ tipo: "erro", mensagem: "CEP não encontrado." });
        return;
      }

      setForm((prev) => ({
        ...prev,
        rua: dados.logradouro || "",
        bairro: dados.bairro || "",
        cidade: dados.localidade || "",
        uf: dados.uf || "",
      }));

    } catch (error) {
      setRetorno({ tipo: "erro", mensagem: "Erro ao consultar o CEP." });
      console.error(error);
    } finally {
      setBuscandoCep(false);
    }
  }

  // ==========================
  // VALIDATION
  // ==========================
  function validarCampos() {
    const e = {};

    if (!form.nome) e.nome = "Informe o nome";
    if (!form.email) e.email = "Informe o e-mail";
    if (!form.login) e.login = "Informe o login";
    if (!form.celular) e.celular = "Informe o celular";

    if (modo === "novo") {
      if (!form.senha) e.senha = "Informe a senha";
      if (!form.confirmarSenha)
        e.confirmarSenha = "Confirme a senha";
    }

    if (form.senha && form.senha !== form.confirmarSenha) {
      e.confirmarSenha = "As senhas não coincidem";
    }

    return e;
  }

  // ==========================
  // SUBMIT (CREATE / UPDATE)
  // ==========================

    async function handleSubmit(e) {
    e.preventDefault();

    const validation = validarCampos();
    setErrors(validation);
    if (Object.keys(validation).length) return;

    setLoading(true);
    setSubmitState("IDLE");

    try {
      if (modo === "novo") {
        const payload_create = formCadastroDTO({
          nome: form.nome,
          nascimento: form.nascimento,
          email: form.email,
          login: form.login,
          senha: form.senha,
          celular: form.celular,
          rua: form.rua,
          numero: Number(form.numero),
          bairro: form.bairro,
          complemento: form.complemento,
          cep: form.cep,
          cidade: form.cidade,
          uf: form.uf
        });

        delete payload_create.confirmarSenha;

        await CadastrosInternosService.create(payload_create);

        setRetorno({
          tipo: "sucesso",
          mensagem: "Cadastro realizado com sucesso!",
        });
      }

      if (modo === "alterar") {
        const payload_update = formCadastroUpdateDTO({
          nome: form.nome,
          nascimento: form.nascimento,
          email: form.email,
          login: form.login,
          celular: form.celular,
          rua: form.rua,
          numero: Number(form.numero),
          bairro: form.bairro,
          complemento: form.complemento,
          cep: form.cep,
          cidade: form.cidade,
          uf: form.uf,
          acesso: Number(form.acesso),
          ativo: Boolean(form.ativo),
        });

        await CadastrosInternosService.update(
          form.idCadastro,
          payload_update
        );

        setRetorno({
          tipo: "sucesso",
          mensagem: "Cadastro atualizado com sucesso!",
        });
      }

      setSubmitState("SUCCESS");
      onClose();
    } catch (error) {
      setRetorno({
        tipo: "erro",
        mensagem:
          modo === "novo"
            ? "Erro ao criar cadastro."
            : "Erro ao atualizar cadastro.",
      });
      setSubmitState("ERROR");
    } finally {
      setLoading(false);
    }
  }
  // ==========================
  // RENDER
  // ==========================
  return (
    <div className="Form-Interno-Container">
      <form onSubmit={handleSubmit}>
        <div className="Form-Interno-title">
          <img src={cadastro} alt="cadastros" className="icon" />
          {modo === "novo"
            ? "Cadastro de clientes"
            : "Alterar cadastro"}
        </div>

        <div className="Form-Interno-linha"></div>

          <div className="Form-Interno-alinhamento">
            <div className="Form-Interno-label">Nome: *</div>
            <input name="nome" value={form.nome} onChange={handleChange} />
            {errors.nome && <span style={{ color: "red" }}>{errors.nome}</span>}
          </div>

          <div className="Form-Interno-alinhamento">
            <div className="Form-Interno-label">Nascimento: *</div>
            <input type="date" name="nascimento" value={form.nascimento} onChange={handleChange} />
          </div>

          <div className="Form-Interno-alinhamento">
            <div className="Form-Interno-label">Email: *</div>
            <input name="email" value={form.email} onChange={handleChange} />
            {errors.email && <span style={{ color: "red" }}>{errors.email}</span>}
          </div>

          <div className="Form-Interno-alinhamento">
            <div className="Form-Interno-label">Login: *</div>
            <input name="login" value={form.login} onChange={handleChange} />
            {errors.login && <span style={{ color: "red" }}>{errors.login}</span>}
          </div>

          <div className="Form-Interno-alinhamento">
            <div className="Form-Interno-label">Senha: *</div>
            <input type="password" name="senha" value={form.senha} onChange={handleChange} />
             {errors.senha && <span style={{ color: "red" }}>{errors.senha}</span>}
          </div>

          <div className="Form-Interno-alinhamento">
            <div className="Form-Interno-label">Confirmar Senha: *</div>
            <input
              type="password"
              name="confirmarSenha"
              value={form.confirmarSenha}
              onChange={handleChange}
            />
            {errors.confirmarSenha && <span style={{ color: "red" }}>{errors.confirmarSenha}</span>}
          </div>

          <div className="Form-Interno-alinhamento">
            <div className="Form-Interno-label">Celular: *</div>
            <input name="celular" value={form.celular} onChange={handleChange} />
             {errors.celular && <span style={{ color: "red" }}>{errors.celular}</span>}
          </div>

          <div className="Form-Interno-alinhamento-cep">
            <div className="Form-Interno-label">CEP:</div>

            <div style={{ display: "flex", gap: "10px", flexDirection: "row" }}>
              <input
                name="cep"
                value={form.cep}
                onChange={handleChange}
                maxLength={9}
                placeholder="00000-000"
                className="cep"
              />

              <button type="button" onClick={buscarCep} disabled={buscandoCep}>
                {buscandoCep ? "Buscando..." : "Buscar"}
              </button>
            </div>
          </div>

          <div className="Form-Interno-alinhamento">
            <div className="Form-Interno-label">Rua:</div>
            <input name="rua" value={form.rua} onChange={handleChange} />
          </div>

          <div className="Form-Interno-alinhamento">
            <div className="Form-Interno-label">Número:</div>
            <input name="numero" value={form.numero} onChange={handleChange} />
          </div>

          <div className="Form-Interno-alinhamento">
            <div className="Form-Interno-label">Bairro:</div>
            <input name="bairro" value={form.bairro} onChange={handleChange} />
          </div>

          <div className="Form-Interno-alinhamento">
            <div className="Form-Interno-label">Complemento:</div>
            <input name="complemento" value={form.complemento} onChange={handleChange} />
          </div>

          <div className="Form-Interno-alinhamento">
            <div className="Form-Interno-label">Cidade:</div>
            <input name="cidade" value={form.cidade} onChange={handleChange} />
          </div>

          <div className="Form-Interno-alinhamento">
            <div className="Form-Interno-label">UF:</div>
            <input name="uf" maxLength={2} value={form.uf} onChange={handleChange} />
          </div>

          {modo === "alterar" && (
            <>
              <div className="Form-Interno-alinhamento">
                <div className="Form-Interno-label">Acesso:</div>

                <select name="acesso" value={form.acesso} onChange={handleChange}>
                  <option value={1}>Administrador</option>
                  <option value={2}>Cliente</option>
                </select>
              </div>

              <div className="Form-Interno-alinhamento">
                <div className="Form-Interno-label">Status:</div>
                <select name="ativo" value={String(form.ativo)} onChange={handleChange}>
                  <option value="true">Ativo</option>
                  <option value="false">Inativo</option>
                </select>
              </div>
            </>
          )}

          <div className="Form-Interno-alinhamento-button">
            <button type="submit" disabled={loading} className="Form-Interno-button">
              {loading ? "Enviando..." : "Cadastrar"}
            </button>

            <button type="button" className="Form-Interno-button" onClick={onClose}>
              Voltar
            </button>
          </div>
        </form>
    </div>
  );
}
